import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'

const CardsFilters = ({ cor, titulo, valor }) => {
    return (
        <Grid xs={3} gap={2} sx={{
            height: '100%',
            backgroundColor: cor,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '10px',
            boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.322)'
        }}>
            <Typography sx={{
                fontSize: '30px',
                color: 'white'
            }}>{valor}</Typography>
            <Typography sx={{
                fontSize: '20px',
                color: 'white'
            }}>{titulo}</Typography>
        </Grid>
    )
}

export default CardsFilters
